import React from 'react'
import {observer} from 'mobx-react'

import type {Service, StandardDeps} from './service'

export {RouterHandler as Handler}

@observer
class RouterHandler extends React.Component<{service: Service, deps: StandardDeps}> {
    componentDidMount() {
        this.props.service.start(this.props.deps)
        this.forceUpdate()
    }

    componentWillUnmount() {
        const {service} = this.props
        service.stop()
        service.clearUrl()
    }

    render() {
        const {page, running} = this.props.service
        if (!running)
            return null
        return [
            page && React.createElement(page.component, {model: page.route.model, route: page.route, key: 'page'}),
            ...[...this.props.service.overlays].map(o =>
                o.model && React.createElement(o.component, {model: o.model, key: o.id, overlay: o})
            ),
        ]
    }
}

@observer
export class CommonOverlaysHandler extends React.Component<{service: Service}> {
    render() {
        return [...this.props.service.commonOverlays].map(o =>
            o.model && React.createElement(o.component, {model: o.model, key: o.id, overlay: o})
        )
    }
}
